import React from "react";
import ProductCard from "../../components/ProductCard";
import ProDetailModal from "../homepage/components/ProDetailModal";
import SideCart from "../../globalcomponents/SideCart/SideCart";

const DUMMY_RELEVANT_PRODUCTS: Partial<any>[] = [
  {
    _id: "rel-1",
    name: "Dolce & Gabbana Greta Tote",
    description:
      "Dolce & Gabbana's 'Greta' tote has been crafted in Italy from hard-wearing red textured-leather.",
    mainImage: "/assets/img/products/product-1.png",
    vendors: { marketedBy: "Dolce & Gabbana" },
    variations: [
      {
        ssin: "VAR-REL-1",
        sku: "DG-GRETA-RED",
        pricing: { unitPrice: 2800, offerPrice: 1549, finalPrice: 1549, gsttype: "inclusive" },
      },
    ],
    reviews: { averageRating: 4.0, totalReviews: 1250 },
    freeDelivery: true,
  },
  {
    _id: "rel-2",
    name: "Armani Classic Leather Wallet",
    description:
      "Premium leather bifold wallet with RFID protection and elegant finish.",
    mainImage: "/assets/img/products/product-2.png",
    vendors: { marketedBy: "Giorgio Armani" },
    variations: [
      {
        ssin: "VAR-REL-2",
        sku: "GA-WALLET-BLK",
        pricing: { unitPrice: 3200, offerPrice: 1899, finalPrice: 1899, gsttype: "inclusive" },
      },
    ],
    reviews: { averageRating: 4.5, totalReviews: 890 },
    freeDelivery: true,
  },
  {
    _id: "rel-3",
    name: "Gucci Signature Canvas Tote",
    description:
      "Iconic monogram canvas tote with premium leather trim and comfortable straps.",
    mainImage: "/assets/img/products/product-3.png",
    vendors: { marketedBy: "Gucci" },
    variations: [
      {
        ssin: "VAR-REL-3",
        sku: "GC-TOTE-BRN",
        pricing: { unitPrice: 4500, offerPrice: 2999, finalPrice: 2999, gsttype: "inclusive" },
      },
    ],
    reviews: { averageRating: 4.7, totalReviews: 2100 },
    freeDelivery: true,
  },
  {
    _id: "rel-4",
    name: "Prada Nylon Crossbody Bag",
    description:
      "Lightweight and durable nylon crossbody bag with enamel logo plaque.",
    mainImage: "/assets/img/products/product-4.png",
    vendors: { marketedBy: "Prada" },
    variations: [
      {
        ssin: "VAR-REL-4",
        sku: "PR-CROSS-BLK",
        pricing: { unitPrice: 3800, offerPrice: 2499, finalPrice: 2499, gsttype: "inclusive" },
      },
    ],
    reviews: { averageRating: 4.3, totalReviews: 640 },
    freeDelivery: true,
  },
  {
    _id: "rel-5",
    name: "Versace Medusa Leather Clutch",
    description:
      "Luxurious leather clutch featuring gold-tone Medusa hardware detail.",
    mainImage: "/assets/img/products/product-5.png",
    vendors: { marketedBy: "Versace" },
    variations: [
      {
        ssin: "VAR-REL-5",
        sku: "VS-CLUTCH-GLD",
        pricing: { unitPrice: 5000, offerPrice: 3299, finalPrice: 3299, gsttype: "inclusive" },
      },
    ],
    reviews: { averageRating: 4.6, totalReviews: 1450 },
    freeDelivery: true,
  },
  {
    _id: "rel-6",
    name: "Burberry Check Shoulder Bag",
    description:
      "Classic shoulder bag featuring Burberry vintage check pattern and leather straps.",
    mainImage: "/assets/img/products/product-6.png",
    vendors: { marketedBy: "Burberry" },
    variations: [
      {
        ssin: "VAR-REL-6",
        sku: "BB-SHOULDER-BEI",
        pricing: { unitPrice: 4200, offerPrice: 2799, finalPrice: 2799, gsttype: "inclusive" },
      },
    ],
    reviews: { averageRating: 4.4, totalReviews: 980 },
    freeDelivery: true,
  },
];

const RelevantProducts = () => {
    
  return (
    <>
      <div className="display-max">
        <div className="d-flex justify-content-start align-items-stretch gap-2 mt-3 overflow-auto hide-scrollbar pb-2">
          {DUMMY_RELEVANT_PRODUCTS.map((product, index) => (
            <div
              className="flex-shrink-0 d-flex"
              style={{ width: 240 }}
              key={product._id}
            >
              <ProductCard product={product as any} index={index} />
            </div>
          ))}
        </div>
      </div>

      <div className="display-mini display-mob">
        <div className="mt-3 mb-3">
          <div className="d-flex justify-content-start align-items-stretch px-1 overflow-auto hide-scrollbar gap-2 pb-2">
            {DUMMY_RELEVANT_PRODUCTS.map((product, index) => (
              <div
                className="flex-shrink-0 d-flex"
                style={{ width: 200 }}
                key={product._id}
              >
                <ProductCard
                  product={product as any}
                  index={index}
                  variant="mini"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <SideCart />
      <ProDetailModal product={DUMMY_RELEVANT_PRODUCTS[0] as any}/>

    </>
  );
};

export default RelevantProducts;
